import React from "react"
import SubNavbar from "./navbar/subNavbar.js"

const StackHeader = (props) => (
  <div className="relative flex-shrink-0 py-5 bg-primary" style={{zIndex: 49}}>
    <div className="px-5 mx-auto max-w-screen-2xl lg:px-0 md:max-w-2xl lg:max-w-7xl lg:px-5 xl:px-0 xl:max-w-7xl 2xl:max-w-screen-2xl">
      <div
        className="flex justify-end py-0"
      >
        <SubNavbar {...props}/>
      </div>
    </div>
  </div>
)

export default StackHeader
